import { 
  ResetPasswordModel, 
} from './reset-password.model';

import { 
  BaseClass,
  dropProps,
} from 'src/api/models/Base/base.class';

import { InputModel } from 'src/api/models/Form/InputField/input.model';

import { InputClass } from 'src/api/models/Form/InputField/input.class';

import { resetPasswordFormData } from './reset-password.data';

export class ResetPasswordClass extends BaseClass<ResetPasswordModel> implements ResetPasswordModel {
  get email(): InputModel {
    return dropProps(this.props.email, new InputClass(this.props.email)); 
  }
}

export const resetPasswordFormValues = () => resetPasswordFormData && dropProps(
  resetPasswordFormData(), 
  new ResetPasswordClass(resetPasswordFormData())
);
